<div mat-dialog-content >
   <app-booking-dialog
     [activity]="data.activity"
   ></app-booking-dialog>
</div>